module.exports = require('../dist/selectors/banking');
